import { asc, count } from "drizzle-orm";
import { organization, type PowerSyncDrizzleDB } from "@aula/powersync";

/**
 * Shared Drizzle query builder for fetching organization counts.
 */
export function getOrganizationCountQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({
      count: count(organization.id).mapWith(Number),
    })
    .from(organization);
}

/**
 * Organizations to which user belongs (local-first). The `organizations`
 * stream only syncs orgs where user is a member, so reading local
 * table returns "my orgs". Used by leaderboard league selector
 * (each org is a league).
 */
export function getMyOrganizationsQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ id: organization.id, name: organization.name })
    .from(organization)
    .orderBy(asc(organization.name));
}
